import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import { Placeholder } from "react-bootstrap";

const estimateTime = [
  {
    label: "1:00:00",
    value: "1:00:00",
  },
  {
    label: "2:00:00",
    value: "2:00:00",
  },
  {
    label: "3:00:00",
    value: "3:00:00",
  },
  {
    label: "4:00:00",
    value: "4:00:00",
  },
  {
    label: "5:00:00",
    value: "5:00:00",
  },
  {
    label: "6:00:00",
    value: "6:00:00",
  },
  {
    label: "7:00:00",
    value: "7:00:00",
  },
  {
    label: "8:00:00",
    value: "8:00:00",
  },
  {
    label: "9:00:00",
    value: "9:00:00",
  },
  {
    label: "10:00:00",
    value: "10:00:00",
  },
];

const AddIssue = () => {
  const [formData, setFormData] = useState({ issue_status: 0 });
  const authToken = localStorage.getItem("authToken");
  const businessPartnerId=localStorage.getItem("business_partner_id")
  const location = useLocation();
  const { jobCarddata, jobCarddataId } = location?.state || {};
  const [activeSection, setActiveSection] = useState("Customer");
  const [businessPartnertypedd, setBusinessPartnerTypedd] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
  const [complainList, setComplainList] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);
  const [repair, setRepair] = useState([]);
  const navigate = useNavigate();

  const IssueInputs = [
    {
      name: "Complain",
      label: "Complain",
      type: "dropdown",
      required: true,
      // options: options,
      options: complainList,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "Complain_Description",
      label: "Complain Description",
      placeholder: "Enter Complain Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        maxLength: 50,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "estimated_cost",
      label: "Estimate Cost",
      placeholder: "Enter Estimate Cost",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
        message: "Only digits and up to 2 decimal places are allowed",
       },
    },
    {
      name: "technician",
      label: "Technician",
      type: "dropdown",
      required: true,
      // options: options,
      options: technicianList || [],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
        maxLength: 50,
      },
    },
    {
      name: "issue_status",
      label: "Issue Status",
      type: "dropdown",
      options: [
        { label: "Pending", value: 0 },
        { label: "Done", value: 1 },
      ],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "repair",
      label: "Repair",
      type: "dropdown",
      options: repair || [],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      dropdownOptionsListPosition: "top",
    },
    {
      name: "east_time",
      label: "Estimate Time",
      placeholder: "Enter Estimate Time",
      type: "text",
      //options: estimateTime || [],
      required: true,
      gridClass: "col-lg-4",
      disabled: true,
      validation: { required: true },
    },
    {
      name: "actual_time",
      label: "Actual Time",
      placeholder: "Enter Actual time",
      type: "dropdown",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      options: estimateTime || [],
    },
  ];

  const fetchComplainList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Complain",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchTecnicianList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Technician",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setTechnicianList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchRepairList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Repair",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setRepair(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;
    IssueInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    if (jobCarddata?.comp_id) {
      try {
        const response = await axiosInstance.post(
          "/jobcardcomplain/jobcardcomplainupdate",
          {
            business_partner_id:businessPartnerId==0?1:businessPartnerId ,

            job_card_id: jobCarddata?.job_card_id || null,
            comp_id: jobCarddata?.comp_id,
            complain_id: data?.Complain || null,
            complain_desc: data?.Complain_Description || null,
            estcost: data?.estimated_cost || null,
            technician_id: data?.technician || null,
            remark: data?.remark || null,
            issue_status: data?.issue_status,
            esttime: data?.east_time || null,
            tech_remark: null,
            repair_id: data?.repair || null,
            actual_time: data?.actual_time || null,
            status: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response?.status) {
          console.log("AddIssueData", response?.data);
          const AddIssueData = response?.data?.data?.jobcardcomplainDetails;

          navigate("/manage-services/technician-to-do/technician-details", {
            state: { data: JSON.parse(JSON.stringify(AddIssueData)) },
          });
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    } else {
      try {
        const response = await axiosInstance.post(
          "/jobcardcomplain/create",
          {
            business_partner_id:businessPartnerId==0?1:businessPartnerId ,

            job_card_id: jobCarddataId || null,
            complain_id: data?.Complain || null,
            complain_desc: data?.Complain_Description || null,
            estcost: data?.estimated_cost || null,
            technician_id: data?.technician || null,
            remark: data?.remark || null,
            issue_status: data?.issue_status,
            esttime: data?.east_time || null,
            tech_remark: null,
            actual_time: data?.actual_time || null,
            repair_id: data?.repair || null,
            status: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response?.status) {
          const AddIssueData = response?.data?.data?.responseData;
          navigate("/manage-services/technician-to-do/technician-details", {
            state: { data: JSON.parse(JSON.stringify(AddIssueData)) },
          });
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };

  useEffect(() => {
    fetchComplainList();
    fetchTecnicianList();
    fetchRepairList();
  }, []);

  const backNavigate = () => {
    navigate("/manage-services/technician-to-do");
  };

  useEffect(() => {
    if (jobCarddata?.comp_id) {
      setFormData({
        Complain: jobCarddata?.complain_id,
        Complain_Description: jobCarddata?.complain_desc,
        estimated_cost: jobCarddata?.estcost,
        remark: jobCarddata?.remark,
        issue_status: jobCarddata?.issue_status,
        east_time: jobCarddata?.esttime,
        repair: jobCarddata?.repair_id,
        technician: jobCarddata?.technician_id,
        actual_time: jobCarddata?.actual_time,
      });
    }
  }, [jobCarddata]);

  return (
    <>
      <ToastContainer />
      <div className="backbutton mt-2 mb-2">
        <img onClick={backNavigate} src={backicon} alt="back" />
        <span className="backbtntitle">
          {jobCarddata?.comp_id ? "Update Issue" : "Add Issue"}
        </span>
      </div>
      <div className="form-container">
        <div className="cust-det-title mt-2 mb-2">Issue Details</div>
        <DynamicForm
          formConfig={IssueInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          {isLoading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </>
  );
};

export default AddIssue;
